import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';
import reportWebVitals from './reportWebVitals';
import { AuthProvider } from "react-oidc-context";
import {CustomAuthProvider} from "./contexts/AuthContext";
import {resolveCognitoAuthority, resolveCognitoScope} from "./utils/authConfig";

console.log('process.env.REACT_APP_COGNITO_CLIENT_ID: ', process.env.REACT_APP_COGNITO_CLIENT_ID)
const cognitoAuthConfig = {
  authority: resolveCognitoAuthority(process.env),
  client_id: process.env.REACT_APP_COGNITO_CLIENT_ID,
  redirect_uri: process.env.REACT_APP_DOMAIN,
  response_type: "code",
  scope: resolveCognitoScope(),
};

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <AuthProvider {...cognitoAuthConfig}>
      <CustomAuthProvider>
        <App />
      </CustomAuthProvider>
    </AuthProvider>
  </React.StrictMode>
);
// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
